import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=06be4e8c&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=06be4e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be4e8c",
  null
  
)

export default component.exports